interface Props {
  title: string
  subtitle?: string
}

export default function ComingSoon({ title, subtitle }: Props) {
  return (
    <div className="max-w-3xl mx-auto px-6 py-24 text-center">
      <h1 className="text-3xl font-bold text-hoop-text mb-2">
        {title}
      </h1>
      {subtitle && (
        <p className="text-hoop-text-3 mb-6">{subtitle}</p>
      )}
      <span className="inline-block px-3 py-1 rounded-full bg-hoop-amber-bg text-hoop-amber text-sm font-medium">
        Coming soon
      </span>
    </div>
  )
}
